let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fJRo2")).then(() => parcelRequire('3JiAU'));